import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import Message from 'components/atoms/Message';
import { PortType, RootState } from 'types';
import { ActionsType } from 'types/system';
import { translate } from 'utils/translate';

interface ReplayModeTimeOutModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;
    id?: string;

    //unused props
    data: any;

    actions: ActionsType | undefined;

    //unused props
    port: PortType;
}

interface ReplayModeTimeOutModelState {
    //unused state
    errors: object;

    //unused state
    data: any | null;

    loading: boolean;
}

class ReplayModeTimeOutModel extends Component<ReplayModeTimeOutModelProps, ReplayModeTimeOutModelState> {
    constructor(props: ReplayModeTimeOutModelProps) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            loading: false,
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onConfirm();
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                    <div className="text-lg leading-6 font-bold">{translate('Unused transit playback detected')} </div>
                    <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                        <Icon>
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M18 6l-12 12" />
                            <path d="M6 6l12 12" />
                        </Icon>
                    </div>
                </div>

                <div className="flex capitalize flex-col items-start text-left gap-1 text-md text-gray-500">
                    <Message className="my-2" type="error">
                        {translate(
                            'You have left this transit playback idle for a while. To keep things running smoothly, please close unused tabs.'
                        )}
                    </Message>

                    <div> {translate('Would you like to close this tab now?')}</div>
                </div>

                <div className="flex justify-end">
                    <div className="mt-5 flex gap-3">
                        <Button className="px-4 py-1" onClick={this.handleFormCancel}>
                            {translate('No , Keep Open')}
                        </Button>
                        <Button
                            disabled={this.state.loading}
                            loading={this.state.loading}
                            type="submit"
                            className="px-4 py-2 bg-primary-submit rounded-md text-white"
                        >
                            {translate('Yes, Close Tab')}
                        </Button>
                    </div>
                </div>
            </Form>
        );
    }
}

const replayModeTimeOutModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    port: state.port.port,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const replayModeTimeOutModelDispatchToProps = () => ({});

export default connect(
    replayModeTimeOutModelStateToProps,
    replayModeTimeOutModelDispatchToProps
)(ReplayModeTimeOutModel);
